import { ReactNode, useRef } from 'react';
import { Carousel } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

// Реестр «пользы опций» для значка «инфо» в групповом Эксперте.
// Ключ = ConfigurationItem.name. Значение — готовый контент (текст/картинки).
//
// weight_system и hydraulic_slide_gates показываются отдельными богатыми модалками
// (WeightSystemOptionModal / SlideGatesModal). Если для опции тут нет записи —
// generic-модалка покажет описание/пользу/картинку с бэка.
//
// Картинки кладём в public/images/options/ и берём по URL (/images/options/...).

// Слайды карусели «весовой системы с передачей данных и GPS»: картинка + пояснения.
const weightGpsSlides = [
  {
    img: '/images/options/weight-gps-1.png',
    items: [
      'Какой комбайн произвёл выгрузку',
      'Вес зерна, принятого от комбайна',
      'Дата и время операции',
      'Координаты операции',
    ],
  },
  {
    img: '/images/options/weight-gps-2.png',
    items: [
      'Вес зерна, загруженного в зерновоз',
      'В какой зерновоз была выгрузка',
      'Время и координаты операции',
      'Опционально: с какого поля собрано зерно',
    ],
  },
  {
    img: '/images/options/weight-gps-3.png',
    items: [
      'Информация о ходе уборки',
      'Аналитика производительности техники',
      'Урожайность полей',
      'Соревновательная система для поощрения лучших сотрудников',
    ],
  },
];

const WeightGpsInfo = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref = useRef<any>(null);
  const arrowClass =
    'absolute top-[115px] -translate-y-1/2 z-10 flex h-9 w-9 items-center ' +
    'justify-center rounded-full bg-white/70 text-[#292E3A] text-[20px] ' +
    'cursor-pointer hover:bg-white transition';
  return (
    <div className="relative">
      <Carousel
        ref={ref}
        arrows={false}
        dots
        draggable
        className="pb-[28px] [&_.slick-slide]:!opacity-100 [&_.slick-slide>div]:!opacity-100">
        {weightGpsSlides.map((s, i) => (
          <div key={i}>
            <img
              src={s.img}
              style={{ filter: 'none', opacity: 1 }}
              className="block mx-auto h-[230px] object-contain"
            />
            <ul className="list-disc mx-auto mt-[20px] max-w-[820px] pl-[28px] text-left font-light text-[24px] leading-snug">
              {s.items.map((t, j) => (
                <li key={j}>{t}</li>
              ))}
            </ul>
          </div>
        ))}
      </Carousel>
      <button
        type="button"
        aria-label="Назад"
        onClick={() => ref.current?.prev()}
        className={`${arrowClass} left-1`}>
        <LeftOutlined />
      </button>
      <button
        type="button"
        aria-label="Вперёд"
        onClick={() => ref.current?.next()}
        className={`${arrowClass} right-1`}>
        <RightOutlined />
      </button>
    </div>
  );
};

export const optionInfo: Record<string, ReactNode> = {
  weight_gps: <WeightGpsInfo />,
  // Другие опции добавляй по имени: <имя_опции>: (<>...текст/картинки...</>),
};
